import React from 'react';
import { Button, Checkbox, Form, Header, Icon, Input, Segment, Table } from 'semantic-ui-react';

const PipelineEditor = ({ title, description, pipeline, errors = {}, onChange }) => {
    const { included, name, stages } = pipeline;

    const updateStages = (newStages) => onChange({ ...pipeline, stages: newStages });
    const updateStage = (id, changes) => updateStages(stages.map(stage => stage.id === id ? { ...stage, ...changes } : stage));
    const moveStage = (index, direction) => {
        const newStages = stages.slice();
        const [stage] = newStages.splice(index, 1);
        newStages.splice(index + direction, 0, stage);
        updateStages(newStages);
    }
    const addStage = () => updateStages([...stages, { id: `${pipeline.account_stage}_custom_${Date.now()}`, name: '', days: 1 }]);

    return (
        <Segment className={`Onboarding__recommendation ${included ? 'Onboarding__recommendation--selected' : ''}`}>
            <div className='Onboarding__recommendation-header'>
                <Checkbox
                    toggle
                    checked={included}
                    onChange={(_, { checked }) => onChange({ ...pipeline, included: checked })}
                    label={<label><b>{title}</b></label>}
                />
            </div>
            <p className='Onboarding__recommendation-summary'>{description}</p>
            {included && (
                <Form className='Onboarding__pipeline'>
                    <Form.Field width={8} error={!!errors.name}>
                        <label>Pipeline Name</label>
                        <Input value={name} onChange={(_, { value }) => onChange({ ...pipeline, name: value })} />
                        {errors.name && <div className='Onboarding__field-error'>{errors.name}</div>}
                    </Form.Field>
                    <Table compact unstackable className='Onboarding__stages'>
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell width={1}>#</Table.HeaderCell>
                                <Table.HeaderCell>Stage</Table.HeaderCell>
                                <Table.HeaderCell width={3}>Target Days</Table.HeaderCell>
                                <Table.HeaderCell width={3} />
                            </Table.Row>
                        </Table.Header>
                        <Table.Body>
                            {stages.map((stage, index) => {
                                const stageErrors = errors.stages?.[stage.id] || {};
                                return (
                                    <Table.Row key={stage.id}>
                                        <Table.Cell>{index + 1}</Table.Cell>
                                        <Table.Cell>
                                            <Form.Field error={!!stageErrors.name}>
                                                <Input size='small' fluid value={stage.name} placeholder='Stage name' onChange={(_, { value }) => updateStage(stage.id, { name: value })} />
                                                {stageErrors.name && <div className='Onboarding__field-error'>{stageErrors.name}</div>}
                                            </Form.Field>
                                        </Table.Cell>
                                        <Table.Cell>
                                            <Form.Field error={!!stageErrors.days}>
                                                <Input size='small' fluid type='number' min={1} value={stage.days} onChange={(_, { value }) => updateStage(stage.id, { days: value === '' ? '' : Number(value) })} />
                                                {stageErrors.days && <div className='Onboarding__field-error'>{stageErrors.days}</div>}
                                            </Form.Field>
                                        </Table.Cell>
                                        <Table.Cell textAlign='right' className='Onboarding__stage-controls'>
                                            <Icon name='arrow up' link={index > 0} disabled={index === 0} onClick={() => index > 0 && moveStage(index, -1)} aria-label='Move stage up' />
                                            <Icon name='arrow down' link={index < stages.length - 1} disabled={index === stages.length - 1} onClick={() => index < stages.length - 1 && moveStage(index, 1)} aria-label='Move stage down' />
                                            <Icon name='trash alternate outline' color='red' link={stages.length > 1} disabled={stages.length === 1} onClick={() => stages.length > 1 && updateStages(stages.filter(({ id }) => id !== stage.id))} aria-label='Remove stage' />
                                        </Table.Cell>
                                    </Table.Row>
                                );
                            })}
                        </Table.Body>
                    </Table>
                    <Button basic size='small' type='button' onClick={addStage}><Icon name='plus' /> Add Stage</Button>
                </Form>
            )}
        </Segment>
    );
}

export const PipelinesHeader = ({ explanation }) => (
    <Header as='h3'>
        Lead & Opportunity Pipelines
        <Header.Subheader>{explanation}</Header.Subheader>
    </Header>
);

export default PipelineEditor;
